import React, { useState } from 'react'

import { Drawer } from '@mui/material'
import { AppBar as ReactAdminAppBar, useAuthState } from 'react-admin'
import HelpCircleOutlineIcon from '@mui/icons-material/HelpOutlineRounded'
import IconButton from '@mui/material/IconButton'

import { AccountSwitch } from './AccountSwitch'
import { HelpView } from './HelpView'
import { UserMenu } from './UserMenu'
import { WhatsNewView } from './WhatsNewView'

type DrawerType = 'whats-new' | 'help'

export const AppBar = (props) => {
  const [drawer, setDrawer] = useState<DrawerType>(null)
  const { authenticated, isLoading } = useAuthState()

  const closeDrawer = (): void => setDrawer(null)
  const openDrawer = (drawerType: DrawerType): void => setDrawer(drawerType)

  return (
    <ReactAdminAppBar
      {...props}
      style={{ background: 'linear-gradient(90deg, #5E2FC3 0%, #E14B1A 100%)' }}
      elevation={0}
      userMenu={<UserMenu />}
    >
      <img height={17} src="/img/brand/powcloud-logo-white-400w.png"></img>
      <span
        style={{
          flex: 1,
        }}
      />
      {!isLoading && authenticated && <AccountSwitch />}
      <IconButton onClick={() => openDrawer('help')} aria-label="Help" color="inherit">
        <HelpCircleOutlineIcon />
      </IconButton>
      <Drawer anchor="right" open={!!drawer} onClose={closeDrawer}>
        {drawer == 'whats-new' ? <WhatsNewView /> : <HelpView onClose={closeDrawer} />}
      </Drawer>
    </ReactAdminAppBar>
  )
}
